import { defineStore } from 'pinia';

import { Constants } from '@/constants';

export const useDashboardStore = defineStore({
  id: 'dashboard',
  state: () => ({}),
  getters: {},
  actions: {
    getTimePeriods(t: (key: string) => string) {
      return [
        { value: Constants.Dashboard.TimePeriod.Yesterday, label: t('dashboard.time-periods.yesterday') },
        { value: Constants.Dashboard.TimePeriod.ThisWeek, label: t('dashboard.time-periods.week') },
        { value: Constants.Dashboard.TimePeriod.LastSevenDays, label: t('dashboard.time-periods.seven-days') },
        { value: Constants.Dashboard.TimePeriod.ThisMonth, label: t('dashboard.time-periods.month') },
        { value: Constants.Dashboard.TimePeriod.LastThirtyDays, label: t('dashboard.time-periods.thirty-days') },
      ];
    },
    getTypes(t: (key: string) => string) {
      return [
        { value: Constants.Dashboard.Type.Consultation, label: t('dashboard.types.consultation') },
        { value: Constants.Dashboard.Type.Project, label: t('dashboard.types.project') },
      ];
    },
  },
});
